// import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import MapControls from './MapControls'
import { zoomIn, zoomOut, zoomToGeolocation, togglePolygonMode, openSearch } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	useGeolocation: "geolocation" in navigator,
	isInSelectMode: state.selectWithPolygon
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onZoomInClick: () => dispatch(zoomIn()),
	onZoomOutClick: () => dispatch(zoomOut()),
	onGeolocationClick: () => dispatch(zoomToGeolocation()),
	onPolygonClick: () => dispatch(togglePolygonMode()),
	onSearchClick: () => dispatch(openSearch())
});

export default connect(mapStateToProps, mapDispatchToProps)(MapControls);


// WEBPACK FOOTER //
// ./src/components/MapMenu/MapControlsContainer.js